import React from 'react';
import { Container } from 'react-bootstrap';
import { StockTransferForm } from "../Components";
import StockTransferFormV2 from "../Components/StockTransferFormV2";

const EditStockTransfer = () => {
  return (
    <Container fluid className="p-0">
      {/* <StockTransferForm isEdit={true} /> */}
      <StockTransferFormV2 isEdit={true} />
    </Container>
  );
};

export default EditStockTransfer;
